/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useRef, useState } from 'react'
import { removeEmptyValueFromObject, toMenuHref } from '~src/util'

export type MenuData = any

type MenuItemProps = {
  data: MenuData[]
}

type MenuProps = MenuItemProps & {
  initData: MenuData[]
  renderChildren?: (data: { item: MenuData }) => JSX.Element | null
}

export const Menu: React.FC<MenuProps> = ({ data, initData, renderChildren }) => {
  const router = useRouter()
  const pathname = router?.pathname === '/' ? undefined : router?.pathname
  const [currentItem, setCurrentItem] = useState<MenuData | undefined>()
  const timeoutRef = useRef<any>(null)

  const handleMouseEnter = (menu: any) => {
    // Clear timeout nếu có
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setCurrentItem(menu)
  }

  const handleMouseLeave = () => {
    // Đặt timeout 300ms trước khi set undefined
    timeoutRef.current = setTimeout(() => {
      setCurrentItem(undefined)
    }, 300)
  }

  if (!data?.length) return null
  return (
    <div className="relative px-[1rem] pb-[0rem] pr-[1rem] pt-[0]">
      <ul className="custom-scrollbar w-[307px] max-h-[70vh] overflow-y-auto pr-[1rem]">
        {data?.map((menu, index) => {
          const active = pathname === menu?.content
          const hasChildren =
            menu?.url_key?.startsWith('brand/') ||
            menu?.children?.length ||
            Number(menu?.children_count) > 0 ||
            [...initData].filter((val: any) => val?.parent_id === menu?.node_id)?.length
          const showChild =
            currentItem &&
            (currentItem?.entity_id || currentItem?.node_id || currentItem?.id) ===
              (menu?.entity_id || menu?.node_id || menu?.id)

          let query: ProductFilterReq = {}
          const urls = menu.categories_uids
          if (urls?.length) {
            query = removeEmptyValueFromObject({
              company: urls?.[0],
              type: urls?.[1],
              end: urls?.[2],
              tag: urls?.[3],
              submitted: true,
            })
          }

          return (
            <li
              key={index}
              className="border-b border-[#F5F5F5] border-solid last:border-b-0"
              onMouseEnter={() => handleMouseEnter(menu)}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                href={{
                  pathname: menu?.url_key?.includes('/category')
                    ? '/category'
                    : toMenuHref(menu?.url_key),
                  query,
                }}
                key={menu?.content}
              >
                <a className="flex gap-[8px] items-center min-h-[54px] py-[1rem] cursor-pointer group item-menu-header">
                  {menu?.icon_image || menu?.image || menu?.image_icon_menu || menu?.logo ? (
                    <div className="">
                      <img
                        className="w-[28px] h-[28px] lg:w-[32px] lg:h-[32px] object-cover flex-shrink-0 rounded-full"
                        src={menu?.icon_image || menu?.image || menu?.image_icon_menu || menu?.logo}
                        alt=""
                        width={24}
                      />
                    </div>
                  ) : null}

                  <div className="flex-1 flex items-center overflow-hidden">
                    <p
                      className={clsx(
                        'in-1-line text-[1.6rem] font-semibold flex flex-1 leading-[25px] select-none hover:text-green text-[#2C0709]',
                        showChild && 'text-green'
                      )}
                    >
                      {menu?.title}
                    </p>
                    {hasChildren ? (
                      <span className="ml-[8px]">
                        {/* {active ? (
                          <img src="/icons/arrow-up.svg" alt="" />
                        ) : (
                          <img src="/icons/arrow-right.svg" alt="" />
                        )} */}
                        <img src="/icons/arrow-right.svg" alt="" className="ic-menu" />
                      </span>
                    ) : null}
                  </div>
                </a>
              </Link>

              {showChild ? renderChildren?.({ item: currentItem }) : null}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

// /* eslint-disable @next/next/no-img-element */
// import clsx from 'clsx'
// import Link from 'next/link'
// import { useRef, useState } from 'react'
// import { removeEmptyValueFromObject } from '~src/util'

// export type MenuDataNode = {
//   uid: string
//   tags: any
//   name: string
//   level: number
//   url_key: string
//   url_path: string
//   meta_description: string | null
//   meta_keywords: string | null
//   image: string | null
//   image_car: string | null
//   id: number
//   image_banner: string | null
//   image_catalogue: string | null
//   children?: MenuDataNode[]
// }

// const SUB_MENU_WRAPPER_CLASS =
//   'absolute bg-white z-[1000] shadow-md min-h-full left-full top-0 overflow-auto header-menu-child'

// type MenuProps = {
//   data: MenuDataNode[]
//   renderChildren?: (data: { item: MenuDataNode }) => JSX.Element | null
// }

// function getLinkQuery(menu: MenuDataNode): ProductFilterReq {
//   const urls = (menu as MenuDataNode & { categories_uids?: string[] }).categories_uids
//   if (!urls?.length) return {}
//   return removeEmptyValueFromObject({
//     company: urls[0],
//     type: urls[1],
//     end: urls[2],
//     tag: urls[3],
//     submitted: true,
//   })
// }

// export const Menu: React.FC<MenuProps> = ({ data, renderChildren }) => {
//   console.log('🚀 ~ Menu ~ data:', data)
//   const [currentItem, setCurrentItem] = useState<MenuDataNode | undefined>()
//   const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

//   const handleMouseEnter = (menu: MenuDataNode) => {
//     if (timeoutRef.current) clearTimeout(timeoutRef.current)
//     setCurrentItem(menu)
//   }

//   const handleMouseLeave = () => {
//     timeoutRef.current = setTimeout(() => setCurrentItem(undefined), 300)
//   }

//   if (!data?.length) return null

//   return (
//     <div className="relative px-[1rem] pb-[0rem] pr-[1rem] pt-[0]">
//       <ul className="custom-scrollbar w-[307px] max-h-[70vh] overflow-y-auto pr-[1rem]">
//         {data.map((menu) => {
//           const hasChildren = Boolean(menu.children?.length)
//           const showChild = currentItem?.id === menu.id
//           const pathnameHref = menu.url_path?.includes('/category')
//             ? '/category'
//             : '/' + menu.url_path
//           const query = getLinkQuery(menu)

//           return (
//             <li
//               key={menu.id}
//               className="border-b border-[#F5F5F5] border-solid last:border-b-0"
//               onMouseEnter={() => handleMouseEnter(menu)}
//               onMouseLeave={handleMouseLeave}
//             >
//               <Link href={{ pathname: pathnameHref, query }}>
//                 <a className="flex gap-[8px] items-center min-h-[54px] py-[1rem] cursor-pointer group item-menu-header">
//                   {menu.image ? (
//                     <div className="">
//                       <img
//                         className="w-[28px] h-[28px] lg:w-[32px] lg:h-[32px] object-cover flex-shrink-0 rounded-full"
//                         src={menu.image}
//                         alt=""
//                         width={24}
//                       />
//                     </div>
//                   ) : null}

//                   <div className="flex-1 flex items-center overflow-hidden">
//                     <p
//                       className={clsx(
//                         'in-1-line text-[1.6rem] font-semibold flex flex-1 leading-[25px] select-none hover:text-green text-[#2C0709]',
//                         showChild && 'text-green'
//                       )}
//                     >
//                       {menu.name}
//                     </p>
//                     {hasChildren ? (
//                       <span className="ml-[8px]">
//                         <img src="/icons/arrow-right.svg" alt="" className="ic-menu" />
//                       </span>
//                     ) : null}
//                   </div>
//                 </a>
//               </Link>

//               {showChild &&
//                 (renderChildren
//                   ? renderChildren({ item: menu })
//                   : hasChildren &&
//                     menu.children && (
//                       <div className={SUB_MENU_WRAPPER_CLASS}>
//                         <Menu data={menu.children} />
//                       </div>
//                     ))}
//             </li>
//           )
//         })}
//       </ul>
//     </div>
//   )
// }
